import { SolApp } from '@sol/components';
import { SolIcon } from '@sol/icons';
import { AsmLicensingAuthority } from '@asm/components-core/models/asm-licensing-authority';
import { AsmRouteId } from '@asm/components-core/models/asm-route-id';
import { navbarLicensing } from './navbar-licensing';

export const apps: SolApp[] = [
  SolApp.ofInternal(
    AsmRouteId.app_licensing,
    'Licensing administration',
    SolIcon.license,
    'Internal apps',
    navbarLicensing,
    [AsmLicensingAuthority.VIEW_APP],
  ),
];
